import * as moment from "moment";
import NotificationBase from "../NotificationBase";
import {LeadBDPChangeNotificationDataApiDto, NotificationBaseApiDto} from "../../../api/model/rest";
import {getUser} from "../../../store/view/user";
import LeadBDPChangeNotificationData from "./LeadBDPChangeNotificationData";

/**
 * Lead BDP changed notification.
 */
export default class LeadBDPChangeNotification extends NotificationBase {
	constructor(readonly id: string,
		readonly visibleFrom: moment.Moment,
		readonly read: boolean,
		readonly type: string,
		readonly data: LeadBDPChangeNotificationData) {
		super(id, visibleFrom, read, type);
	}

	static fromJson(json: NotificationBaseApiDto): LeadBDPChangeNotification {
		return new LeadBDPChangeNotification(json.id, moment(json.visibleFrom), json.read, json.type,
			LeadBDPChangeNotificationData.fromJson(json.data as LeadBDPChangeNotificationDataApiDto));
	}

	/**
	 * Display user Full name.
	 */
	displayCreatorName(): string {
		return getUser(this.data.entity.id).map(u => u.getDisplayName()).getOrElse(this.data.entity.id);
	}

	/**
	 * Display previous bdp full name
	 */
	displayPreviousAssignee(): string {
		return this.data.previousBusinessDevelopmentPartnerId
			.map(id => getUser(id).map(u => u.getDisplayName()).getOrElse("Unassigned"))
			.getOrElse("Unassigned");
	}

	/**
	 * Display current bdp full name
	 */
	displayCurrentAssignee(): string {
		return this.data.currentBusinessDevelopmentPartnerId
			.map(id => getUser(id).map(u => u.getDisplayName()).getOrElse("Unassigned"))
			.getOrElse("Unassigned");
	}

	copy({id = this.id, dateTime = this.visibleFrom, read = this.read, type = this.type, data = this.data}) {
		return new LeadBDPChangeNotification(id, dateTime, read, type, data);
	}
}